<template>
    <div class="brands-content">
        <el-input v-model="searchVal" :placeholder="$t('reportAuditing.pleaseKeyWord')" prefix-icon="el-icon-search"
            size="medium"></el-input>

        <div class="limit-box">
            <div class="tree-box treeScrollBar" :style="cssStyle">
                <el-tree :data="treeData" :class="{ activeClass: !chooseTreeAction }" default-expand-all node-key="id"
                    ref="tree" :expand-on-click-node="false" :props="defaultProps" :filter-node-method="filterNode"
                    :highlight-current="true" @node-click="nodeClick" @node-expand="nodeExpand">
                    <div slot-scope="{ node, data }">
                        <template v-if="data.type === 'camera'">
                            <img src="../../../../assets/icon/playing.svg"
                                v-if="playCameraNoList.includes(data.id.replace('c_', ''))" class="sys-channel-icon" />
                            <img src="../../../../assets/icon/realplay.svg" v-else class="sys-channel-icon" />
                        </template>
                        {{ node.label }}
                    </div>
                </el-tree>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        treeData: {
            type: Array,
            default() {
                return []
            }
        },
        checkMaps: {
            type: Array,
            default() {
                return []
            }
        },
    },
    watch: {
        searchVal(val) {
            this.$refs.tree.filter(val);
        },
        checkMaps(val) {
            this.playCameraNoList = val;
        }
    },
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            cssStyle: 'height: 300px;',
            searchVal: '',
            chooseTreeAction: true,
            playCameraNoList: [],
        }
    },
    mounted() {
        this.playCameraNoList = this.checkMaps;
        this.cssStyle = 'height:' + (document.body.clientHeight - 268) + 'px;'
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        nodeClick(node) {
            this.chooseTreeAction = false;
            if (node.type === 'camera') {
                this.$emit('clickSide', node.id.replace('c_', ''), node.name);
            }
        },
        nodeExpand(obj, node, treeObj) {
            let treeStore = this.$refs.tree.store;
            this.changeTreeNodeStatus(treeStore.root, obj.id)
        },
        // 改变节点的状态
        changeTreeNodeStatus(node, brandId) {
            node.expanded = true;
            for (let i = 0; i < node.childNodes.length; i++) {
                if (node.childNodes[i].data.level === 1) {
                    if (node.childNodes[i].data.id === brandId) {
                        // 改变节点的自身expanded状态
                        node.childNodes[i].expanded = true;
                        // 遍历子节点
                        if (node.childNodes[i].childNodes.length > 0) {
                            this.changeTreeNodeStatus(node.childNodes[i])
                        }
                    }
                } else {
                    // 改变节点的自身expanded状态
                    node.childNodes[i].expanded = true;
                    // 遍历子节点
                    if (node.childNodes[i].childNodes.length > 0) {
                        this.changeTreeNodeStatus(node.childNodes[i])
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.brands-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #F8F8F8;
    padding: 24px 10px;
    border-radius: 2px;
}

.tree-box {
    overflow: auto;
}

.sys-channel-icon {
    width: 20px;
    height: 20x;
    margin-right: 10px;
    cursor: pointer;
    vertical-align: top;
}

::v-deep .el-tree-node>.el-tree-node__children {
    overflow: visible;
}

.el-tree {
    background: #F8F8F8 !important;
}

</style>

<style lang="scss">
.limit-box {
    margin-top: 25px;

    // .el-tree-node.is-current {
    //     .el-tree-node__content {
    //         background-color: #fff;
    //     }
    // }

    .activeClass {
        .el-tree-node.is-current>.el-tree-node__content {
            background: $theme-color-2;
        }

        .el-tree-node.is-current>.el-tree-node__content .custom-tree-node .el-tooltip {

            color: $theme-color;
        }
    }

}
</style>